import React from "react";
import { Helmet } from "react-helmet-async";

const Deoghar = () => {
  return (
    <>
      <Helmet>
        <title>Fly Ash Bricks, Blocks & Paver Blocks in Deoghar | Anil Flyash Bricks</title>
        <meta
          name="description"
          content="Anil Flyash Bricks offers high-quality fly ash bricks, blocks, and paver blocks in Deoghar. Trusted dealer and manufacturer for durable, eco-friendly, and affordable construction materials."
        />
        <meta
          name="keywords"
          content="bricks in Deoghar, flyash bricks in Deoghar, fly ash blocks in Deoghar, flyash bricks dealer in Deoghar, flyash bricks manufacturer Deoghar, paver block supplier Deoghar, construction materials in Deoghar, Anil Flyash Bricks Deoghar"
        />
        <link rel="canonical" href="https://anilbricks.com/flyash-bricks-in-deoghar" />
      </Helmet>

      <div className="py-16 px-6 md:px-20 bg-gray-50 text-gray-800">
        <h1 className="text-3xl font-bold mb-6 text-green-700 text-center">
          Fly Ash Bricks, Blocks & Paver Blocks in Deoghar
        </h1>

        <p className="text-lg leading-relaxed mb-4">
          Welcome to <strong>Anil Flyash Bricks</strong> — the most trusted supplier and 
          manufacturer of <strong>fly ash bricks, fly ash blocks, and paver blocks</strong> 
          in <strong>Deoghar</strong>, Jharkhand. We specialize in producing strong, eco-friendly, 
          and affordable construction materials for every type of project.
        </p>

        <p className="text-lg leading-relaxed mb-4">
          Our <strong>fly ash bricks</strong> are made using advanced technology that ensures
          uniform shape, high strength, and excellent finishing. Whether you're building a
          home, commercial building, or industrial structure, our bricks and blocks provide 
          unmatched durability and energy efficiency.
        </p>

        <p className="text-lg leading-relaxed mb-4">
          In addition to bricks, we supply premium <strong>paver blocks</strong> in multiple 
          patterns, textures, and colors — perfect for footpaths, parking areas, and driveways.
          Our <strong>fly ash blocks</strong> are lightweight yet strong, reducing construction
          time and cost while supporting sustainable building practices.
        </p>

        <p className="text-lg leading-relaxed mb-4">
          Whether you are searching for <em>“bricks dealers in Deoghar”</em>, 
          <em>“paver block manufacturer near me”</em>, or 
          <em>“fly ash blocks supplier in Jharkhand”</em>, 
          <strong>Anil Flyash Bricks</strong> is your one-stop solution. 
          We deliver across <strong>Deoghar, Jasidih, Mohanpur, Madhupur</strong>, and nearby regions.
        </p>

        <p className="text-lg leading-relaxed mb-6">
          Choose us for long-lasting products, competitive pricing, and professional service. 
          Contact us today for bulk supply, dealership, or franchise opportunities in Deoghar.
        </p>

        <a
          href="/"
          className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-full font-semibold shadow-md transition"
        >
          Visit Main Website
        </a>
      </div>
    </>
  );
};

export default Deoghar;
